import { useFormContext } from 'react-hook-form'
import type { AssetLocation } from '../../../data/locations.tsx'
import type { BaseReportForm } from './schema.ts'

export const useSelectLocations = (onLocationsSelected: (locations: AssetLocation[]) => void) => {
	const { setValue } = useFormContext<BaseReportForm>()

	return (locations: AssetLocation[]) => {
		onLocationsSelected(locations)
		setValue(
			'assetVrns',
			locations.map((location) => location.assetVrn),
			{ shouldValidate: true },
		)
		setValue('customPoint', undefined)
	}
}
